module.exports = __webpack_public_path__ + "img/clock-transparent.28950d25.gif";